import { MdWifiTethering } from "react-icons/md";
import { cn } from "@/lib/utils";

type ExclusiveReleaseBadgeProps = {
  className?: string;
  hoverExpand?: boolean;
  badgeOnly?: boolean;
};

/**
 * Badge indicating exclusive content available only on Lutely.
 * Designed for use on dark/image backgrounds (banners, cards, etc.)
 */
export default function ExclusiveReleaseBadge({
  className,
  hoverExpand = false,
  badgeOnly = false,
}: ExclusiveReleaseBadgeProps) {
  const iconOnly = hoverExpand || badgeOnly;
  return (
    <div
      className={cn(
        "group inline-flex items-center h-7 rounded-sm bg-gray-900 text-white font-open-sans font-semibold text-xs uppercase tracking-wide transition-all duration-300",
        hoverExpand
          ? "gap-0 w-7 overflow-hidden hover:gap-1.5 hover:w-fit hover:pr-3"
          : badgeOnly
            ? "gap-0 w-7 overflow-hidden"
            : "gap-1.5 px-3",
        className,
      )}
    >
      <MdWifiTethering
        className={cn(
          "w-4 h-4 text-teal-500",
          iconOnly && "flex-shrink-0 mx-1.5",
        )}
      />
      <span
        className={
          hoverExpand
            ? "opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            : badgeOnly
              ? "hidden"
              : ""
        }
      >
        Exclusive Release
      </span>
    </div>
  );
}
